import { render, staticRenderFns } from "./PopupEditTaskGroup.vue?vue&type=template&id=5961a21b&scoped=true&"
import script from "./PopupEditTaskGroup.vue?vue&type=script&lang=js&"
export * from "./PopupEditTaskGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5961a21b",
  null
  
)

export default component.exports